/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

// defines the definition of the save icon in-progress props
export interface SaveIconInChangeProps extends IconProps{
  changeColor?: string;
};
  
/*
 * Defines the Design Language System (DLS) Save Icon In Change component.
 */
export const SaveIconInChange = ({color, size, ...props}: SaveIconInChangeProps) => {
  const {iconSize = 24, iconColor = dlsColor('grey1')} = useIconDLS({color, size});
  const {changeColor = dlsColor('caRed')} = props;
  return (
    <svg width={iconSize}
      height={iconSize}
      viewBox={'0 0 25 25'}
      fill={'none'}>
      <circle cx='23' cy='2' r='2' fill={changeColor}/>
      <path d='M17.1464 4.14645C17.0527 4.05268 16.9255 4 16.7929 4H5C3.89 4 3 4.9 3 6V20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V8.20711C21 8.0745 20.9473 7.94732 20.8536 7.85355L17.1464 4.14645ZM12 13C10.34 13 9 14.34 9 16C9 17.66 10.34 19 12 19C13.66 19 15 17.66 15 16C15 14.34 13.66 13 12 13ZM6 7.5C6 7.22386 6.22386 7 6.5 7H14.5C14.7761 7 15 7.22386 15 7.5V10.5C15 10.7761 14.7761 11 14.5 11H6.5C6.22386 11 6 10.7761 6 10.5V7.5Z'
        stroke={iconColor}
        strokeWidth={'1.5'}
        strokeMiterlimit={'10'}/>
    </svg>
  );
};
